"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateClassName = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("@material-ui/utils");
var _StylesProvider = _interopRequireWildcard(require("../style/StylesProvider"));
var _excluded = ["children", "intl"];
/*:: // 

import { type Node } from 'react';*/
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/*:: type Rule = { key: string };*/
/*:: type StyleSheet = { options: { meta: string } };*/
var generateClassName = exports.generateClassName = function generateClassName(rule /*: Rule*/, styleSheet /*: StyleSheet*/) {
  var _styleSheet$options;
  return "".concat(styleSheet === null || styleSheet === void 0 ? void 0 : (_styleSheet$options = styleSheet.options) === null || _styleSheet$options === void 0 ? void 0 : _styleSheet$options.meta, "-").concat(rule === null || rule === void 0 ? void 0 : rule.key, "-test");
};
/*:: type Props = {
  children: Node,
  generateClassName: (rule: Rule, sheet: StyleSheet) => string
};*/
var MockedStylesProvider = function MockedStylesProvider(_ref /*:: */) {
  var _React$Children$only, _React$Children$only$, _React$Children$only$2;
  var children = _ref /*:: */.children,
    intl = _ref /*:: */.intl,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  // For react-cosmos, get display name from fixture component.
  var displayName = (0, _utils.getDisplayName)((_React$Children$only = _react.default.Children.only(children)) === null || _React$Children$only === void 0 ? void 0 : (_React$Children$only$ = _React$Children$only.props) === null || _React$Children$only$ === void 0 ? void 0 : (_React$Children$only$2 = _React$Children$only$.fixture) === null || _React$Children$only$2 === void 0 ? void 0 : _React$Children$only$2.component);
  if (displayName) {
    return /*#__PURE__*/_react.default.createElement(_StylesProvider.default, (0, _extends2.default)({}, props, {
      generateClassName: function generateClassName(rule /*: Rule*/) {
        return "".concat(displayName, "-").concat(rule === null || rule === void 0 ? void 0 : rule.key, "-test");
      }
    }), children);
  }
  return /*#__PURE__*/_react.default.createElement(_StylesProvider.default, props, children);
};
MockedStylesProvider.displayName = 'MockedStylesProvider';
MockedStylesProvider.defaultProps = {
  generateClassName: generateClassName,
  jss: _StylesProvider.jss
};
var _default = exports.default = MockedStylesProvider;
//# sourceMappingURL=MockedStylesProvider.js.map